import gsap from 'gsap'

import { gridAnimation, SharedAnimation } from './shared'
import { Animation } from '@/types'

export const team = ({ node, reverse, mobile, context }: Animation) => {
  if (mobile) return

  const selector = context?.selector || gsap.utils.selector(node)

  const members = selector('[data-team-member]')

  const scrollTrigger = {
    trigger: node,
    once: !reverse,
    start: 'top 80%',
    markers: false,
    toggleActions: `play none none ${reverse ? 'reverse' : 'none'}`
  }

  const timeline = gsap.timeline({
    scrollTrigger
  })

  let animation: SharedAnimation
  if (members) {
    animation = gridAnimation(members)
    timeline.add(animation.timeline, '<')
  }

  return () => {
    if (animation) {
      animation.revert()
    }
  }
}
